"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputSwitch = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const inputswitch_1 = require("primereact/inputswitch");
const react_1 = require("react");
const InputSwitch = (props) => {
    const handleChange = (0, react_1.useCallback)((event) => {
        if (props.onChange) {
            props.onChange(event.value);
        }
    }, [props.onChange]);
    return ((0, jsx_runtime_1.jsx)(inputswitch_1.InputSwitch, { className: 'size-small', checked: props.value, onChange: handleChange }));
};
exports.InputSwitch = InputSwitch;
